// extracted by mini-css-extract-plugin
export default {"movie":"Movie_movie__QpuTw"};